import { styled } from '../Theme';

const StyledFieldset = styled('fieldset', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  border: 'none',
  backgroundColor: 'transparent',
});

export const Fieldset = StyledFieldset;
